import BaseModule from "@/components/site-builder/BaseModule";
import CustomForm from "@/components/site-builder/modules/CustomFormModule/components/CustomForm";
import CustomFormContainer from "@/components/site-builder/modules/CustomFormModule/components/CustomFormContainer";
import { CustomFormContextProvider } from "@/components/site-builder/modules/CustomFormModule/context/customFormContext";
import { CustomFormQueryProvider } from "@/components/site-builder/modules/CustomFormModule/context/customFormQueryProvider";
import { GoogleReCaptchaProvider } from "@/components/site-builder/modules/CustomFormModule/context/googleRecaptchaProvider";
import type { CustomFormModuleType } from "./types";

export interface CustomFormModuleProps {
  module: CustomFormModuleType;
}

export default function CustomFormModule(props: CustomFormModuleProps) {
  const { module } = props;

  if (!module.extraContent.data) {
    return null;
  }

  return (
    <BaseModule module={module}>
      <CustomFormQueryProvider>
        <GoogleReCaptchaProvider
          reCaptchaKey={module.extraContent.data.recaptchaSiteKey}
        >
          <CustomFormContextProvider
            value={{
              formBody: module.body,
              formEntity: module.extraContent,
            }}
          >
            <CustomFormContainer>
              <CustomForm />
            </CustomFormContainer>
          </CustomFormContextProvider>
        </GoogleReCaptchaProvider>
      </CustomFormQueryProvider>
    </BaseModule>
  );
}
